import { useEffect, useState } from "react";
import CommonComponents from "../../../Commons";

export const ReasonCancelReject = ({
      setReasson,
      reason,
      t,
}: {
      setReasson: any;
      reason: string;
      t?: any;
}) =>
{
      const [touched, setTouched] = useState(false);

      useEffect(() =>
      {
            return () =>
            {
                  setReasson("");
            };
      }, []);
      return (
            <div>
                  <CommonComponents.TextAreaUI
                        onChange={(event: any) =>
                        {
                              setReasson(event.target.value);
                        }}
                        // label={t("Reason")}
                        placeholder={t("Enter reason ....")}
                        onBlur={() =>
                        {
                              setTouched(true);
                        }}
                        maxLength={250}
                  />
                  {touched && reason?.trim()?.length <= 0 && (
                        <p className="text-red-500 text-xs mt-1">{t("Reason is required")}</p>
                  )}
            </div>
      );
};